const PLATFORM_CUSTOMIZATION_COOKIE = 'PlatformCustomizationCookie';
const PERSONALIZED_ADVERTISING_COOKIE = 'PersonalizedAdvertisingCookie';

const setCookie = (name: string, value: boolean, days?: number) => {
    let expires = '';
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/';
};

const useCookies = () => ({
    setCookie,
    PLATFORM_CUSTOMIZATION_COOKIE,
    PERSONALIZED_ADVERTISING_COOKIE,
});

export default useCookies;
